import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Label,
  LabelList,
  ResponsiveContainer,
} from "recharts";

function ReportsBarChart({ chartData, pdfLoading=true }) {
  return (
    <ResponsiveContainer width="100%" height={600}>
      <div
        style={{
          width: "auto",
          overflowY: "auto",
          overflowX: "hidden",
          height: "600px",
        }}
      >
        <h3 style={{ textAlign: "center", marginTop: "15px" }}>
          Certification Completion Rates
        </h3>
        {chartData.length === 0 ? (
          <div style={{ textAlign: "center", marginTop: "25px" }}>
            <h3>No data found. Adjust your filters.</h3>
          </div>
        ) : (
          ""
        )}
        <BarChart
          layout={"vertical"}
          width={chartData.length > 8 ? chartData.length * 150 : 1000}
          height={
            chartData.length === 1 
              ? (pdfLoading ? 650 : 350) 
              : chartData.length > 7 
              ? chartData.length * 70 
              : chartData.length * 100
          }
          data={chartData}
          margin={{ top: 5, left: 5, bottom: 25 }}
          barGap={25}
          {...{
            overflow: "visible",
          }}
        >
          <XAxis
            type="number"
            domain={[0, chartData.length > 7 ? (pdfLoading ? chartData.length * 14: chartData.length * 18) : 100]}
            tickFormatter={(value) => `${value}%`}
            width={"100%"}
            allowDataOverflow={true}
            ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          >
            { chartData.length < 2 || pdfLoading ? (
              <Label
                value="Average Completion Percentage"
                position="bottom"
                offset={10}
                style={{ textAnchor: "middle", fontSize: 16 }}
              />
            ) : (
              ""
            )}
          </XAxis>

          <YAxis type="category" dataKey="name" interval={0} width={230}>
            <Label
              value="All Dealerships"
              angle={-90}
              position="left"
              offset={0}
              style={{ textAnchor: "middle", fontSize: 16 }}
            />
          </YAxis>
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend />
          <Bar
            dataKey="completion"
            fill="black"
            barSize={35}
            isAnimationActive={false}
          >
            <LabelList
              dataKey="completion"
              position="right"
              formatter={(value) => `${value}%`}
            />
          </Bar>
        </BarChart>
        {chartData.length > 1 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            Average Completion Percentage
          </div>
        ) : (
          ""
        )}
      </div>
    </ResponsiveContainer>
  );
}

export default ReportsBarChart; 